var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"image__wrap"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.getImageName(_vm.imgSrc),"title":_vm.getImageName(_vm.imgSrc)}})]),_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }